import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../constants/remoteConfigPaths';
import {DynamicContent} from '../DynamicContent';
import {AccreditationRequirements} from '../MerchantAccreditationPolicyTexts/AccreditationRequirements';
import {AleloInspection} from '../MerchantAccreditationPolicyTexts/AleloInspection';
import {DisacceptanceEc} from '../MerchantAccreditationPolicyTexts/DisacceptanceEc';
import {InitialTextMerchantAccreditationPolicy} from '../MerchantAccreditationPolicyTexts/InitialTextMerchantAccreditationPolicy';
import {SignalingInEstablishments} from '../MerchantAccreditationPolicyTexts/SignalingInEstablishments';
import {WorkerFoodProgramPat} from '../MerchantAccreditationPolicyTexts/WorkerFoodProgramPat';
import './MerchantAccreditationPolicy.style.scss';

export const MerchantAccreditationPolicy = () => {
  return (
    <section className="merchants-policy">
      <article className="merchants-policy__content">
        <InitialTextMerchantAccreditationPolicy />
        <AccreditationRequirements />
        <WorkerFoodProgramPat />
        <SignalingInEstablishments />
        <DisacceptanceEc />
        <AleloInspection />
      </article>
      <DynamicContent
        configPath={REMOTE_CONFIG_PATHS.MERCHANT_POLICY.DECLARATION}
        className="merchants-policy__question"
        as="p"
      />
    </section>
  );
};
